document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector('.tm-mobile-nav');
  mobileMenu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { mobileMenu.open = false; }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && mobileMenu?.open) { mobileMenu.open = false; mobileMenu.querySelector('summary').focus(); } });
  document.querySelectorAll('a[href="#quote"]').forEach(link => link.addEventListener('click', () => { window.setTimeout(() => document.getElementById('quote')?.focus({ preventScroll: true }), 0); }));
  document.querySelector('.tm-form-status, .tm-form-error')?.focus();
});
